module.exports = __webpack_public_path__ + "static/downloadGooglePlay-f6dea76e60c22df03ba48c00a1c1aec9.png";